import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Loader2 } from "lucide-react";
import { login, getMe } from "@/lib/api";
import { useEffect } from "react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(true);
  const [alreadyAuth, setAlreadyAuth] = useState(false);

  useEffect(() => {
    getMe()
      .then((r) => {
        if (r.authenticated) setAlreadyAuth(true);
      })
      .catch(() => {})
      .finally(() => setChecking(false));
  }, []);

  if (alreadyAuth) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(err.message || "Errore di login");
    } finally {
      setLoading(false);
    }
  };

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
        <Loader2 className="w-8 h-8 animate-spin text-[#0B1E36]" />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] px-4">
      <Card className="w-full max-w-md p-8">
        <h1 className="text-2xl font-bold text-[#0B1E36] mb-2">Area Admin</h1>
        <p className="text-[#64748B] mb-6 text-sm">
          Accedi per gestire progetti e testimonianze.
        </p>

        <form onSubmit={onSubmit} className="space-y-4" autoComplete="off">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              data-testid="admin-login-email"
            />
          </div>

          <div>
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-login-password"
            />
          </div>

          {error && (
            <div className="p-3 rounded-lg bg-red-50 text-red-700 text-sm border border-red-200">
              {error}
            </div>
          )}

          <Button
            type="submit"
            className="w-full bg-[#0B1E36] hover:bg-[#0B1E36]/90 text-white font-semibold py-6 rounded-full"
            disabled={loading}
            data-testid="admin-login-submit"
          >
            {loading ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" /> Accesso in corso…
              </>
            ) : (
              "Accedi"
            )}
          </Button>
        </form>
      </Card>
    </div>
  );
}
